import { createAction } from '@reduxjs/toolkit';

import { SearchCriteria, SearchFilters } from '@app/models';

/**
 * Initialize search state from URL parameters
 */
export const initSearchFromUrlAction = createAction<{
    searchCriteria: Partial<SearchCriteria>;
    filters: Partial<SearchFilters>;
    campaignListingId?: string;
    page?: number;
}>('search/initFromUrl');

/**
 * Update the search criteria (location, dates, guests)
 * @param shouldUpdateUrl Whether to update URL after updating state (default: false)
 */
export const updateSearchCriteriaAction = createAction<{
    criteria: Partial<SearchCriteria>;
    shouldUpdateUrl?: boolean;
}>('search/updateSearchCriteria');

/**
 * Update the filters (property types, amenities, etc.)
 * @param shouldUpdateUrl Whether to update URL after updating state (default: false)
 */
export const updateSearchFiltersAction = createAction<{
    filters: Partial<SearchFilters>;
    shouldUpdateUrl?: boolean;
}>('search/updateSearchFilters');

/**
 * Set page number
 * @param shouldUpdateUrl Whether to update URL after updating state (default: false)
 */
export const setPageAction = createAction<{
    page: number;
    shouldUpdateUrl?: boolean;
}>('search/setPageAction');

/**
 * Reset campaignListingId to default
 */
export const resetCampaignListingIdAction = createAction('search/resetCampaignListingId');

/**
 * Reset the search criteria to defaults
 */
export const resetSearchCriteriaAction = createAction('search/resetSearchCriteria');

/**
 * Reset the filters to defaults
 */
export const resetSearchFiltersAction = createAction('search/resetSearchFilters');

/**
 * Reset page to default
 */
export const resetPageAction = createAction('search/resetPage');

/**
 * Toggle filters visibility
 */
export const toggleFiltersVisibilityAction = createAction('search/toggleFiltersVisibility');

/**
 * Set filters visibility
 */
export const setFiltersVisibilityAction = createAction<{
    open: boolean;
}>('search/setFiltersVisibility');

/**
 * Set the loading state for search
 */
export const setSearchLoadingAction = createAction<boolean>('search/setLoading');
